import { render, staticRenderFns } from "./movieBox.vue?vue&type=template&id=297c9754&scoped=true"
import script from "./movieBox.vue?vue&type=script&lang=js"
export * from "./movieBox.vue?vue&type=script&lang=js"
import style0 from "./movieBox.vue?vue&type=style&index=0&id=297c9754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c9754",
  null
  
)

export default component.exports